@if (mapReady) {
  <google-chart [data]="geoChart"></google-chart>
}
